import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Project, ProjectProps } from './projectsTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncProjectsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<ProjectProps>>();
const ProjectsPayloadCreator = getPayloadCreator<Project>();

export const getProject = createAction('GET_PROJECT', getPayloadCreator());
export const getProjectSuccess = createAction('GET_PROJECT_SUCCESS', syncProjectsPayloadCreator);
export const getProjectFailure = createAction('GET_PROJECT_FAILURE', errorPayloadCreator);

export const createProject = createAction('CREATE_PROJECT', ProjectsPayloadCreator);
export const createProjectSuccess = createAction('CREATE_PROJECT_SUCCESS', ProjectsPayloadCreator);
export const createProjectFailure = createAction('CREATE_PROJECT_FAILURE', errorPayloadCreator);

export const updateProject = createAction('UPDATE_PROJECT', ProjectsPayloadCreator);
export const updateProjectSuccess = createAction('UPDATE_PROJECT_SUCCESS', ProjectsPayloadCreator);
export const updateProjectFailure = createAction('UPDATE_PROJECT_FAILURE', errorPayloadCreator);

export const deleteProject = createAction('DELETE_PROJECT', ProjectsPayloadCreator);
export const deleteProjectSuccess = createAction('DELETE_PROJECT_SUCCESS', ProjectsPayloadCreator);
export const deleteProjectFailure = createAction('DELETE_PROJECT_FAILURE', errorPayloadCreator);
